import Backbone from 'backbone';
import { on, off, getElement } from 'utils/mixins';
import BaseAPI from '../../../services/BaseAPI';
import Tools from '../../../services/Tools';
const $ = Backbone.$;
var MobileDetect = require('mobile-detect');
const md = new MobileDetect(navigator.userAgent);

module.exports = Backbone.View.extend({
  tagName: 'div',
  template() {
    const icon_emoji = `${this.conf.domain}img/emoji.svg`;
    const upload_file = `${this.conf.domain}img/upload_file.svg`;
    const send_btn = `${this.conf.domain}img/send_mess.svg`;
    return `
      <div class="view_image"></div>
      <div class="view_file"></div>
      <div class="view_mess">
        ${
          !this.conf.disable_sticker
            ? `<img class="sticker" src="${icon_emoji}" >`
            : ''
        }
        <textarea autofocus class="input mf" placeholder="Trả lời..."></textarea>
        ${
          !this.conf.disable_upload
            ? `<div class="attach-file">
                  <label for="file-upload" class="custom-file-upload">
                    <img src="${upload_file}">
                  </label>
                  <input multiple id="file-upload" type="file" accept="image/*,.ogg,.doc,.docx,.pdf,.xlsx,.xls,.mp3,.mp4,video/mp4,video/x-m4v,video/*"/>
                </div>`
            : ''
        } 
        ${`
          <div class="btn-send  bf" style="display: none;">
            <img src="${send_btn}" style="height: 20px;" />
          </div>
          `}
      </div>`;
  },

  initialize(o) {
    _.bindAll(
      this,
      'renderContent',
      'uploadFile',
      'handleUploadFile',
      'handleInputKeyup',
      'handleInputKeydown',
      'handleInputPaste',
      'resetInput',
      'sendMessage',
      'handleInputFocus',
      'handleInputBlur',
      'handleRemoveImageFileClick',
      'handleRemoveFileClick',
      'checkHideSendButton'
    );
    const model = this.model;
    model.view = this;
    this.conf = o.config || {};
    this.pfx = this.conf.stylePrefix || '';
    this.inputHeight = 30;
    this.isMultipleLine = false;
    this.listenTo(
      model,
      'change:showSendBtn',
      this.handleShowSendButtonChanged
    );
  },

  handleShowSendButtonChanged(model, val, options) {
    if (val) {
      this.btnSendEl && this.btnSendEl.css('display', 'block');
      this.fileEl && this.fileEl.css('display', 'none');
      return;
    }
    this.btnSendEl && this.btnSendEl.css('display', 'none');
    this.fileEl && this.fileEl.css('display', 'block');
  },

  handleUploadFile(files) {
    const { model, conf } = this;
    const that = this;
    let file_uploads = [];
    if (files.length > conf.max_file_number) {
      alert(`Không thể tải quá ${conf.max_file_number} file`);
      return;
    }
    model.set('file_upload', undefined);
    this.checkHideSendButton();
    this.clearViewImageContainer();
    this.clearViewFileContainer();

    for (let index = 0; index < files.length; index++) {
      const element = files[index];
      if (element.size > conf.max_one_file_value * 1024) {
        alert(
          `Dung lượng file ${element.name} vượt quá ${conf.max_one_file_value}kb`
        );
        continue;
      }
      const id = Date.now();
      const fileObj = {
        file: element,
        id: id
      };
      var reader = new FileReader();
      reader.onload = function(event) {
        if (element.type.search('image/') != -1) {
          that.addViewImage(fileObj, event);
        } else {
          that.addViewFile(fileObj, event);
        }
        file_uploads.push(fileObj);
        model.set('file_upload', file_uploads);
        model.set('showSendBtn', true);
      };
      reader.readAsDataURL(element);
    }
  },

  addViewImage(fileObj, event) {
    const that = this;
    const iconClose = `${this.conf.domain}img/icon_close.png`;
    this.showImageContainer();
    fileObj.type = 'IMAGE';
    fileObj.image = event.target.result;
    const $child = $(`<div class="fileImage">
                        <div style="position: absolute; right: 2px; top: 2px" id="${fileObj.id}" class="btnRemove"><img class="close" src="${iconClose}" /></div>
                        <img src="${event.target.result}" height="60px"  width="60px">
                      </div>`);
    this.imageContainer.append($child);
    $child.find('.btnRemove').on('click', e => {
      that.handleRemoveFileClick(fileObj.id, $child);
    });
  },

  addViewFile(fileObj, event) {
    const iconClose = `${this.conf.domain}img/icon_close.png`;
    const icon_file = `${this.conf.domain}img/icon_file.png`;
    const that = this;
    this.showFileContainer();
    fileObj.type = 'FILE';
    fileObj.name = Tools.nameFile(fileObj.file.name);
    const $child = $(`<div class="fileView">
                        <div style="position: absolute; right: 0px; top: 5px" class="btnRemove"><img class="close" src="${iconClose}" /></div>
                        <img src="${icon_file}" height="15px"  width="15px">
                        <div class="title mf">${Tools.nameFile(
                          fileObj.file.name
                        )}<div>
                      </div>`);
    this.fileContainer.append($child);
    $child.find('.btnRemove').on('click', e => {
      that.handleRemoveFileClick(fileObj.id, $child);
    });
  },

  handleRemoveImageFileClick(id, $ele) {
    let files = this.model.get('file_upload');
    if (!files || !files.length) {
      this.checkHideSendButton();
      return;
    }
    files = files.filter(item => item.id !== Number(id));
    $ele.remove();

    this.model.set('file_upload', !files.length ? null : files);
    setTimeout(() => {
      this.checkImageFileEmpty();
    }, 50);
  },

  checkImageFileEmpty() {
    this.checkHideSendButton();
    if (!this.imageContainer) {
      return;
    }
    const children = this.imageContainer.children();
    if (!children || !children.length) {
      this.hideImageContainer();
    }
  },

  handleRemoveFileClick(id, $ele) {
    let files = this.model.get('file_upload');
    if (!files || !files.length) {
      return;
    }
    files = files.filter(item => item.id !== Number(id));
    $ele.remove();
    this.model.set('file_upload', !files.length ? null : files);
    setTimeout(() => {
      this.checkFileEmpty();
    }, 50);
  },

  checkHideSendButton() {
    const files = this.model.get('file_upload');
    const val = this.input.val() || '';
    if (val.trim() === '' && (!files || !files.length)) {
      this.model.set('showSendBtn', false);
    }
  },

  checkFileEmpty() {
    this.checkHideSendButton();
    if (!this.fileContainer) {
      return;
    }
    const children = this.fileContainer.children();
    if (!children || !children.length) {
      this.hideFileContainer();
    }
  },

  showFileContainer() {
    this.fileContainer.css('display', 'block');
  },

  hideFileContainer() {
    this.fileContainer.html('').css('display', 'none');
  },

  showImageContainer() {
    this.imageContainer.css('display', 'flex');
  },

  hideImageContainer() {
    this.imageContainer.html('').css('display', 'flex');
  },

  clearViewImageContainer() {
    this.imageContainer.html('');
  },

  clearViewFileContainer() {
    this.fileContainer.html('');
  },

  uploadFile(file, id) {
    const { conf } = this;
    const that = this;
    const socket_id = conf.socket.getId().trim();
    var confix = {
      url: `${conf.domainAPI}/message/upload_files?socket_id=${socket_id}&team_id=${conf.teamID}`,
      method: 'POST',
      body: file
    };
    var headers = {
      cid: conf.userId || Tools.getUserId(conf.domain_id),
      'Content-Type': 'multipart/form-data'
    };
    BaseAPI.callAPI(
      confix,
      headers,
      response => {
        if (response.attachments && response.attachments.length) {
          that.updateAttachmentsAfterUpload(
            response.attachments,
            id,
            response.mid,
            response
          );
        }
      },
      error => {
        console.log('error', error);
      }
    );
  },

  updateAttachmentsAfterUpload(attachments, id, mid, response) {
    if (!attachments || !attachments.length) {
      return;
    }
    console.log('response', response);
    this.model.trigger('onUpdateAttachments', attachments, id, mid, response);
  },

  setEmoji(sticker) {
    const msg = this.input.val() || '';
    this.input.val(`${msg}${sticker}`);
    this.model.set('showSendBtn', true);
  },

  renderContent() {
    const { $el, model, uploadFile, conf, handleUploadFile } = this;
    $el.html(this.template());
    this.imageContainer = $el.find('.view_image');
    this.fileContainer = $el.find('.view_file');
    this.input = $el.find('.input');
    this.fileUploadEl = $el.find('#file-upload');

    if (this.conf.disable_sticker) {
      this.input.css({ 'padding-left': '10px' });
    }

    // drop file
    if (!this.conf.disable_upload) {
      $el.find('.view_mess').on('drop', function(event) {
        event.preventDefault();
        handleUploadFile(event.dataTransfer.files);
      });
    }
    //input file
    this.fileUploadEl.on('change', function(event) {
      handleUploadFile(event.target.files);
    });
    // open sticker
    $el.find('.sticker').on('click', function(e) {
      model.trigger('onOpenSticker', $(this));
    });

    // input listener
    this.input.on('keyup', this.handleInputKeyup);
    this.input.on('keydown', this.handleInputKeydown);
    this.input.on('focus', this.handleInputFocus);
    this.input.on('blur', this.handleInputBlur);
    this.input.on('paste', this.handleInputPaste);
  },

  handleInputFocus(e) {
    this.model.trigger('onFocus');
    this.inputFocus = true;
    setTimeout(() => {
      this.updateContentHeight();
    }, 50);
  },

  updateContentHeight() {
    if (!md.mobile()) {
      return;
    }
    this.model.trigger('onHeightChanged');
    if (this.inputFocus) {
      setTimeout(() => {
        this.updateContentHeight();
      }, 250);
    }
  },

  handleInputBlur(e) {
    this.inputFocus = false;
    this.model.trigger('onBlur');
  },

  handleInputPaste(e) {
    const { model } = this;
    setTimeout(() => {
      const val = (this.input.val() || '').trim();
      const file_upload = model.get('file_upload');
      if (val === '' && !file_upload) {
        model.set('showSendBtn', false);
      } else {
        model.set('showSendBtn', true);
      }
    }, 50);
  },

  /**
   * handle input keydown
   * @param {*} e
   */
  handleInputKeydown(e) {
    const { $el, model } = this;
    const code = e.keyCode ? e.keyCode : e.which;
    if (code == 13 && !e.shiftKey) {
      e.preventDefault();
      this.sendMessage();
    }
  },

  /**
   * handle input keyup
   * @param {*} e
   */
  handleInputKeyup(e) {
    const { $el, model } = this;
    const self = this;
    var code = e.keyCode ? e.keyCode : e.which;

    // autosize input
    setTimeout(function() {
      var el = self.input[0];
      if (self.inputHeight > 30) {
        self.input.css('height', 'auto');
      }
      self.input.css('height', `${el.scrollHeight}px`);
      if (self.inputHeight !== el.scrollHeight) {
        self.inputHeight = el.scrollHeight;
        model.trigger('onHeightChanged');
      }
    }, 0);

    // reset size input
    setTimeout(() => {
      const val = this.input.val() || '';
      if (val.trim().length >= 40) {
        this.isMultipleLine = true;
        return;
      }
      if (val.trim().length < 40 && this.isMultipleLine) {
        this.isMultipleLine = false;
        this.resetInput();
        model.trigger('onHeightChanged');
      }
      const file_upload = model.get('file_upload');
      if (val.trim() === '' && !file_upload) {
        model.set('showSendBtn', false);
      } else {
        model.set('showSendBtn', true);
      }
    }, 50);
  },

  sendMessage() {
    const { model, $el } = this;
    // upload files
    this.uploadFileSubmit();
    // submit message
    const msg = (this.input.val() || '').trim();
    if (msg === '') {
      this.input.val('');
    } else {
      this.input.val('');
      model.trigger('onSubmit', msg);
      model.set('showSendBtn', false);
    }

    // reset input height
    setTimeout(() => {
      this.resetInput();
      model.trigger('onHeightChanged');
    }, 20);
  },

  uploadFileSubmit() {
    const { model, $el } = this;
    const file_upload = model.get('file_upload');
    const form_data = new FormData();
    if (!file_upload) {
      return;
    }
    const idFile = Date.now();
    file_upload.forEach(item => {
      item.idFile = idFile;
      const element = item.file;
      if (element) {
        form_data.append('attachments', element);
        model.trigger('onUploadFile', item);
      }
    });
    this.uploadFile(form_data, idFile);
    model.set('file_upload', undefined);
    setTimeout(() => {
      this.hideImageContainer();
      this.hideFileContainer();
      this.fileUploadEl.val('');
      setTimeout(() => {
        model.trigger('onHeightChanged');
      }, 150);
    }, 0);

    model.set('showSendBtn', false);
  },

  resetInput() {
    this.inputHeight = 30;
    this.input.css('height', '30px');
    this.isMultipleLine = false;
  },

  render() {
    const { $el, model, conf } = this;
    $el.attr({ class: `${this.pfx}message-input` });
    this.renderContent();
    this.fileEl = $el.find('.attach-file');
    this.btnSendEl = $el.find('.btn-send');
    this.btnSendEl.css('background-color', conf.header_color);
    this.btnSendEl.on('click', this.sendMessage);

    return this;
  }
});
